import PaymentComplete from './PaymentComplete';

export default PaymentComplete;
